import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  addShownLanguage,
  addCurrentRoundDetails,
  addNextRoundDetails,
} from '../../store/appSlice'
import { RootState } from '../../store/store'
import { LanguageEntry } from '../../../types/types'
import downloadAudio from '../utils/downloadAudio'
import getRandomFile from '../utils/getRandomFile'
import supabase from '../utils/supabase'

//TODO: rename to start new round
export function useGenerateLanguage() {
  const dispatch = useDispatch()
  const nextRoundDetails = useSelector((state: RootState) => state.nextRound)
  const currentRoundDetails = useSelector(
    (state: RootState) => state.currentRound
  )
  const shownLanguages = useSelector((state: RootState) => state.shownLanguages)

  const generateLanguage = useCallback(async (): Promise<LanguageEntry> => {
    //get available languages
    const languageDataSupabase = await supabase
      .from('language_data')
      .select('*')
      .eq('active', true)
    const languageData = languageDataSupabase.data

    if (!languageData) throw new Error('No language data found')
    const availableLanguages = languageData.filter(
      (row) => !shownLanguages.includes(row.code)
    )

    //generate a random language
    const randomRow = await availableLanguages[
      Math.floor(Math.random() * languageData.length)
    ]

    const newLanguageCode = randomRow.code
    const audioPath = await getRandomFile(newLanguageCode, supabase)
    if (!audioPath) throw new Error('No audio file found')
    //download audio file
    await downloadAudio(audioPath)

    let currentRoundState
    // get two languages for the start
    //TODO: move to separate function & clean the code
    if (shownLanguages.length === 0) {
      // generate second random language
      // exclude randomRow from available languages
      availableLanguages.splice(
        availableLanguages.findIndex((row) => row.code === newLanguageCode),
        1
      )
      const randomRow2 =
        availableLanguages[Math.floor(Math.random() * languageData.length)]
      const newLanguageCode2 = randomRow2.code
      const audioPath2 = await getRandomFile(newLanguageCode2, supabase)
      await downloadAudio(audioPath2)

      dispatch(addShownLanguage(newLanguageCode2))
      dispatch(addCurrentRoundDetails({ ...randomRow, audioPath: audioPath }))
      dispatch(addNextRoundDetails({ ...randomRow2, audioPath: audioPath2 }))
      currentRoundState = { ...randomRow, audioPath: audioPath }
    } else {
      //move nextRound to currentRound
      dispatch(addCurrentRoundDetails(nextRoundDetails))
      //remove currentRound file
      localStorage.removeItem(currentRoundDetails.audioPath)

      //add new language to nextRound
      dispatch(addNextRoundDetails({ ...randomRow, audioPath: audioPath }))
      currentRoundState = nextRoundDetails
    }

    //add languages to shown languages
    dispatch(addShownLanguage(newLanguageCode))

    return currentRoundState
  }, [shownLanguages, dispatch, nextRoundDetails, currentRoundDetails])

  return { generateLanguage }
}
